import React, { useEffect } from 'react';
import * as Yup from "yup";
import { withFormik } from "formik";

import FormikInput from "../../SharedComponents/Forms/FormikFormGroup/FormikInput";
import FormicCheckbox from "../../SharedComponents/Forms/FormikFormGroup/FormicCheckbox";
import {
  companyValidationRequired,
  emailWithUmlautsValidation,
  nameValidation,
  phoneValidation
} from "../../SharedComponents/Forms/ValidationSchemaPattern";
import { EllipsisLoader } from "../../SharedComponents/Loaders";
import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const ContactInfoFormWrapper = ({ errors,
                                  handleBlur,
                                  handleChange,
                                  handleSubmit,
                                  loading,
                                  setErrors,
                                  setFieldValue,
                                  setSubmitErrors,
                                  submitErrors,
                                  touched,
                                  values }) => {


  useEffect(() => {
    if (submitErrors) {
      setErrors(submitErrors);
      setSubmitErrors(null);
    }
  }, [submitErrors]);


  return (
    <form name="continueRegistrationForm" className="company-form" onSubmit={handleSubmit}>

      <input
        id="fifth_element"
        type="text"
        name="fifth_element"
        className="invisible"
        value={values.fifth_element}
        onPaste={handleChange}
        onChange={handleChange}
      />

      <FormikInput
        id="name"
        error={errors.name}
        handleBlur={handleBlur}
        handleChange={(e) => setFieldValue('name', e.target.value.trimStart().replace(/\s\s+/g, ' '))}
        labelPosition="top"
        placeholder="Firmanavn*"
        touched={touched.name}
        value={values.name}
      />

      <FormikInput
        id="contact_person"
        error={errors.contact_person}
        handleBlur={handleBlur}
        handleChange={handleChange}
        labelPosition="top"
        placeholder="Kontaktperson*"
        touched={touched.contact_person}
        value={values.contact_person}
      />

      <FormikInput
        id="email"
        error={errors.email}
        handleBlur={handleBlur}
        handleChange={handleChange}
        labelPosition="top"
        placeholder="E-mail*"
        touched={touched.email}
        value={values.email}
      />

      <FormikInput
        id="phone"
        error={errors.phone}
        handleBlur={handleBlur}
        handleChange={(e) => setFieldValue('phone', e.target.value.trimStart().replace(/\s\s+/g, ' '))}
        labelPosition="top"
        placeholder="Telefonnummer*"
        touched={touched.phone}
        type="tel"
        value={values.phone}
      />

      <FormicCheckbox
        id="sms_order_notification"
        handleBlur={handleBlur}
        handleChange={handleChange}
        label="Modtag SMS meddelelser om kundeemner"
        value={values.sms_order_notification}
      />

      <button type="submit" className={`signup-form__submit-button ${loading ? 'inactive' : ''}`}>
        { loading
          ?
            <EllipsisLoader />
          :
            <div className="signup-form__submit-button-label">
              Næste
              <SvgIcon name="arrow_forward" size={24} />
            </div>
        }
      </button>

    </form>
  )
};


const ContactInfoForm = withFormik({

  mapPropsToValues: (bag) => ({
    contact_person: bag.currentValues.contact_person || '',
    email: bag.currentValues.email || '',
    fifth_element: bag.currentValues.fifth_element || '',
    name: bag.currentValues.name || '',
    phone: bag.currentValues.phone || '',
    sms_order_notification: bag.currentValues.sms_order_notification || false,
  }),

  validationSchema: Yup.object().shape({
    contact_person: nameValidation,
    email: emailWithUmlautsValidation,
    fifth_element: Yup.string(),
    name: companyValidationRequired,
    phone: phoneValidation,
    sms_order_notification: Yup.boolean(),
  }),

  handleSubmit: (values, bag) => {
    bag.props.submitHandler(values);
  },

  displayName: 'ContactInfoForm',
})(ContactInfoFormWrapper);

export default ContactInfoForm;
